var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"layout-info",class:{ _white: _vm.isWhite }},[_c('div',{staticClass:"layout-info__container"},[_c('section',{staticClass:"layout-info__sideblock"},[_c('ui-back',{attrs:{"href":_vm.href,"text":_vm.text}})],1),_c('section',{staticClass:"layout-info__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }